import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    appBar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    },
    appBarLeftContent: {
        display: "flex",
        alignItems: "center",
        marginLeft: "20px",
    },
    // Cedar rebrand: brand wordmark, upper-left, as large as the 64px bar allows
    // (uses the whitespace-trimmed asset so the mark fills the height).
    brandLogo: {
        height: "54px",
        width: "auto",
        objectFit: "contain",
        display: "block",
    },
    // Clickable wrapper so the upper-left logo returns to the active module's home
    // (parity with Cedar). Unstyled button chrome + a subtle hover/focus affordance;
    // the negative margin cancels the padding so the logo stays visually in place.
    brandLogoButton: {
        display: "flex",
        alignItems: "center",
        padding: "2px 6px",
        marginLeft: "-6px",
        border: "none",
        background: "transparent",
        cursor: "pointer",
        borderRadius: "8px",
        transition: "background-color 120ms ease",
        "&:hover": {
            backgroundColor: "rgba(6, 35, 63, 0.06)",
        },
        "&:focus-visible": {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: "2px",
        },
    },
    // Active module (Aspen = Downtime, Birch = RCA) shown right of the logo.
    // Styled to match the "MADERA" wordmark: Aldrich, uppercase, wide tracking.
    moduleName: {
        fontFamily: '"Aldrich", "Source Sans 3", sans-serif',
        fontSize: "24px",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: theme.palette.text.primary,
        whiteSpace: "nowrap",
        // The "MADERA" wordmark sits above the logo image's vertical center (tagline +
        // arrow tail fill the lower half), so nudge this text up to sit on the same line.
        transform: "translateY(-3px)",
    },
    // Selected site name shown next to the module once a mill is open. Same
    // wordmark lettering so the logo + module + mill read as one lockup.
    siteName: {
        fontFamily: '"Aldrich", "Source Sans 3", sans-serif',
        fontSize: "24px",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: theme.palette.text.primary,
        whiteSpace: "nowrap",
        // The "MADERA" wordmark sits above the logo image's vertical center (tagline +
        // arrow tail fill the lower half), so nudge this text up to sit on the same line.
        transform: "translateY(-3px)",
    },
    appBarRightContent: {
        display: "flex",
        alignItems: "center",
    },
    appBarLanguageDropdown: {
        "& label": {
            display: "none",
        },
        "& .MuiInputBase-root": {
            width: "initial !important",
            boxShadow: "none !important",
            marginBottom: 0,
            backgroundColor: `transparent !important`,
        },
        "& .MuiSelect-select": {
            minWidth: "90px !important",
        },
        "& .MuiBox-root": {
            color: `${theme.palette.menu.icons.main} !important`,
        },
        "& .MuiSvgIcon-root": {
            color: `${theme.palette.menu.icons.main} !important`,
            width: `16px !important`,
            height: `16px !important`,
            top: `calc(50% - 0.3em) !important`,
        },
        " & fieldset": {
            border: "none !important",
        },
    },
    toolbarIconButton: {
        width: `20px !important`,
        height: `20px !important`,
        marginRight: `2px !important`,
        backgroundColor: `${theme.palette.info.main} !important`,
        padding: 0,
        "& .MuiSvgIcon-root": {
            color: "#FFFFFF !important",
        },
    },
    avatar: {
        width: `27.5px !important`,
        height: `27.5px !important`,
    },
    menuButton: {
        display: "flex !important",
        gap: "16px !important",
        fontSize: "14px !important",
        fontWeight: `400 !important`,
        fontFamily: "Source Sans 3 !important",
        color: `${theme.palette.menu.icons.main} !important`,
        textTransform: "none !important" as "none",
        "&:hover": {
            backgroundColor: "initial !important",
        },
    },
    expandMoreIcon: {
        width: `16px !important`,
        height: `16px !important`,
    },
    expandMoreIconRotated: {
        width: `16px !important`,
        height: `16px !important`,
        transform: "rotate(180deg) !important",
    },
    divider: {
        borderColor: `${theme.palette.border.divider} !important`,
        marginLeft: "12px !important",
        marginRight: "12px !important",
    },
    appMenu: {
        width: `27.5px !important`,
        height: `27.5px !important`,
        color: `${theme.palette.menu.icons.main} !important`,
    },
}));

export const paperProps = {
    elevation: 0,
    sx: {
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
        mt: 1.5,
        "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
        },
    },
};
